import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import moment from 'moment'
import { getTokenType } from 'utils/tokenTypes'
import ScrollableTable from '../../../components/exchange/ScrollableTable'
import Price from '../../../components/exchange/Price'
import Amount from '../../../components/exchange/Amount'
import LoadingShade from '../../../components/common/LoadingShade'
import Icon from '../../../components/common/Icon'
import { getTradeHistoryQS } from '../../../redux/trade/action'
import { withI18n } from '../../../i18n/util'

import { Wrapper, Title, Content, DateItem, ExpandCollpaseIcon } from './styled'

class TradeHistory extends PureComponent {
  static propTypes = {
    tradeHistory: PropTypes.array,
    userInfo: PropTypes.object,
    currentTrade: PropTypes.string,
    tickerSize: PropTypes.string,
    lotSize: PropTypes.string,
    dispatch: PropTypes.func,
    pairs: PropTypes.array,
    isFetchTradeHistory: PropTypes.bool,
    match: PropTypes.object,
    formatI18nText: PropTypes.func,
    theme: PropTypes.object.isRequired,
  }

  static defaultProps = {
    tradeHistory: [],
    pairs: [],
    userInfo: {},
    currentTrade: '',
    tickerSize: '0.00000001',
    lotSize: '0.00000001',
    dispatch: () => {},
    isFetchTradeHistory: false,
    match: {},
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      isExpand: true,
    }
  }

  componentDidMount() {
    const { match, currentTrade } = this.props
    let {
      params: { symbol },
    } = match
    symbol = symbol || currentTrade
    if (symbol) {
      this._getTradeHistory(symbol)
    }
  }

  componentDidUpdate(prevProps) {
    const { currentTrade } = this.props
    if (currentTrade !== prevProps.currentTrade) {
      this._getTradeHistory(currentTrade)
    }
  }

  _getTradeHistory = symbol => {
    const { dispatch } = this.props
    const tokenType = getTokenType()
    const tradeParams = { offset: 0, limit: 50 }
    tradeParams.symbol = symbol
    tradeParams.end = new Date().getTime()
    dispatch(getTradeHistoryQS({ params: tradeParams, tokenType }))
  }

  _calPriceColor = tickType => {
    const { theme } = this.props
    if (tickType.includes('Sell')) {
      return theme.down
    }
    if (tickType.includes('Buy')) {
      return theme.up
    }
    if (tickType.includes('Neutral')) {
      return theme.up
    }
    return '#fff'
  }

  _buildColumns = () => {
    const { formatI18nText } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.price'),
        headerAlign: 'left',
        dataIndex: 'price',
        key: 'Price',
        width: '35%',
        render: item => (
          <Price value={item.price} priceColor={this._calPriceColor(item.tickType || '')} />
        ),
      },
      {
        title: formatI18nText('exchange.amount'),
        dataIndex: 'amount',
        headerAlign: 'right',
        width: '35%',
        key: 'Amount',
        render: item => <Amount textAlign="flex-end" value={item.amount} />,
      },
      {
        title: formatI18nText('exchange.tradingHistory.time'),
        dataIndex: 'time',
        width: '30%',
        headerAlign: 'right',
        key: 'Time',
        render: item => <DateItem>{item.time}</DateItem>,
      },
    ]

    return columns
  }

  _buildTradeHistory = () => {
    const { tradeHistory } = this.props
    return tradeHistory.map(trade => ({
      tickType: trade.tickType,
      price: trade.p || trade.price,
      amount: trade.q || trade.amount || trade.quantity,
      time: trade.T
        ? moment(new Date(trade.T / 10 ** 6)).format('HH:mm:ss')
        : moment(new Date(trade.time)).format('HH:mm:ss'),
    }))
  }

  _expand = () => {
    const { isExpand } = this.state
    this.setState({ isExpand: !isExpand })
  }

  render() {
    const { isFetchTradeHistory, formatI18nText } = this.props
    const { isExpand } = this.state
    const dataSource = this._buildTradeHistory()
    const columns = this._buildColumns(dataSource)

    return (
      <Wrapper flexGrow={isExpand ? 1 : 0}>
        <Title>{formatI18nText('exchange.tradingHistory.title')}</Title>
        <ExpandCollpaseIcon onClick={this._expand}>
          <Icon type={isExpand ? 'expand' : 'collpase'} size={25} />
        </ExpandCollpaseIcon>
        {isExpand && (
          <Content>
            <ScrollableTable columns={columns} dataSource={dataSource} isFixedHeader={true} />
            {isFetchTradeHistory && dataSource.length === 0 && <LoadingShade />}
          </Content>
        )}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  exchange: { userInfo, currentTrade },
  tradePairs: { pairs },
  trade: { tradeHistory, isFetchTradeHistory },
}) => ({
  userInfo,
  tradeHistory: tradeHistory.trade,
  currentTrade,
  isFetchTradeHistory,
  pairs,
})

export default withI18n(connect(mapStateToProps)(withRouter(withTheme(TradeHistory))))
